import { produce } from "immer";
import {
  FETCH_CARE_HEARTH_BUYER,
  FETCH_CARE_HEARTH_BUYER_FAILURE,
  FETCH_CARE_HEARTH_BUYER_SUCCESS,
  FETCH_CARE_HEARTH_BUYERS,
  FETCH_CARE_HEARTH_BUYERS_FAILURE,
  FETCH_CARE_HEARTH_BUYERS_SUCCESS,
  FETCH_CARE_HEARTH_DISPUTES,
  FETCH_CARE_HEARTH_DISPUTES_FAILURE,
  FETCH_CARE_HEARTH_DISPUTES_SUCCESS,
  FETCH_CARE_HEARTH_INVOICES,
  FETCH_CARE_HEARTH_INVOICES_FAILURE,
  FETCH_CARE_HEARTH_INVOICES_SUCCESS,
  MARK_CARE_HEARTH_INVOICE_PAID,
  MARK_CARE_HEARTH_INVOICE_PAID_FAILURE,
  MARK_CARE_HEARTH_INVOICE_PAID_SUCCESS,
  RAISE_CARE_HEARTH_DISPUTES,
  RAISE_CARE_HEARTH_DISPUTES_FAILURE,
  RAISE_CARE_HEARTH_DISPUTES_SUCCESS,
  RECALCULATE_CARE_HEARTH_BUYER,
  RECALCULATE_CARE_HEARTH_BUYER_FAILURE,
  RECALCULATE_CARE_HEARTH_BUYER_SUCCESS,
} from "./constants";

export const initialState = {
  detail: null,
  detailError: "",
  // The Disputes list: rows, the month's figures, its pages, and whether
  // this admin can raise one for a home.
  disputeCanRaise: false,
  disputeMeta: { current_page: 1, last_page: 1, total: 0 },
  disputeReasons: {},
  disputeSummary: null,
  disputes: [],
  disputesError: "",
  isFetchingDisputes: false,
  isRaisingDisputes: false,
  isFetchingDetail: false,
  isFetchingInvoices: false,
  isFetchingList: false,
  isMarkingPaid: false,
  isRecalculating: false,
  // The invoices list: rows, counts per status tab and its pages.
  invoiceCounts: null,
  invoiceMeta: { current_page: 1, last_page: 1, total: 0 },
  invoices: [],
  invoicesError: "",
  listError: "",
  listItems: [],
  pagination: { last_page: 1, total: 0 },
  summary: null,
};

const CareHearthBuyersReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CARE_HEARTH_BUYERS:
        draft.isFetchingList = true;
        draft.listError = "";
        break;
      case FETCH_CARE_HEARTH_BUYERS_SUCCESS:
        draft.isFetchingList = false;
        draft.listItems = action.payload.items;
        draft.pagination = action.payload.pagination;
        draft.summary = action.payload.summary;
        break;
      case FETCH_CARE_HEARTH_BUYERS_FAILURE:
        draft.isFetchingList = false;
        draft.listError = action.payload;
        break;

      case FETCH_CARE_HEARTH_BUYER:
        draft.isFetchingDetail = true;
        draft.detail = null;
        draft.detailError = "";
        break;
      case FETCH_CARE_HEARTH_BUYER_SUCCESS:
        draft.isFetchingDetail = false;
        draft.detail = action.payload;
        break;
      case FETCH_CARE_HEARTH_BUYER_FAILURE:
        draft.isFetchingDetail = false;
        draft.detailError = action.payload;
        break;

      case RECALCULATE_CARE_HEARTH_BUYER:
        draft.isRecalculating = true;
        break;
      case RECALCULATE_CARE_HEARTH_BUYER_SUCCESS:
      case RECALCULATE_CARE_HEARTH_BUYER_FAILURE:
        draft.isRecalculating = false;
        break;

      case FETCH_CARE_HEARTH_INVOICES:
        draft.isFetchingInvoices = true;
        draft.invoicesError = "";
        break;
      case FETCH_CARE_HEARTH_INVOICES_SUCCESS:
        draft.isFetchingInvoices = false;
        draft.invoices = action.payload.items;
        draft.invoiceCounts = action.payload.counts;
        draft.invoiceMeta = action.payload.meta;
        break;
      case FETCH_CARE_HEARTH_INVOICES_FAILURE:
        draft.isFetchingInvoices = false;
        draft.invoicesError = action.payload;
        break;

      case FETCH_CARE_HEARTH_DISPUTES:
        draft.isFetchingDisputes = true;
        draft.disputesError = "";
        break;
      case FETCH_CARE_HEARTH_DISPUTES_SUCCESS:
        draft.isFetchingDisputes = false;
        draft.disputes = action.payload.items;
        draft.disputeSummary = action.payload.summary;
        draft.disputeMeta = action.payload.meta;
        draft.disputeCanRaise = action.payload.canRaise;
        draft.disputeReasons = action.payload.reasons;
        break;
      case FETCH_CARE_HEARTH_DISPUTES_FAILURE:
        draft.isFetchingDisputes = false;
        draft.disputesError = action.payload;
        break;
      case RAISE_CARE_HEARTH_DISPUTES:
        draft.isRaisingDisputes = true;
        break;
      case RAISE_CARE_HEARTH_DISPUTES_SUCCESS:
      case RAISE_CARE_HEARTH_DISPUTES_FAILURE:
        draft.isRaisingDisputes = false;
        break;
      case MARK_CARE_HEARTH_INVOICE_PAID:
        draft.isMarkingPaid = true;
        break;
      case MARK_CARE_HEARTH_INVOICE_PAID_SUCCESS:
      case MARK_CARE_HEARTH_INVOICE_PAID_FAILURE:
        draft.isMarkingPaid = false;
        break;
      default:
        break;
    }
  });

export default CareHearthBuyersReducer;
